<div>
    <div class="d-flex align-items-center mb-8">
        <div class="mr-8"><span class="material-icons-outlined text-warning">warning_amber</span></div>
        <h4 class="text-warning">Redundant column</h4>
    </div>
    <p>
        "{{newColumnName}}" is equivalent to "{{oldColumnName}}", which is already selected:
    </p>
    <p>
        Do you want to drop "{{oldColumnName}}" and switch to "{{newColumnName}}"?
    </p>
    <div class="mt-24">
        <button (click)="switch()" class="btn btn-primary mr-16">Switch</button>
        <button mat-dialog-close class="btn btn-secondary">Cancel</button>
    </div>
    <a mat-dialog-close class="btn-close material-icons-outlined">close</a>
</div>
